import styled from 'styled-components';
import { palette } from 'styled-theme';

export const TextareaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 100%;
`;

export const Label = styled.label`
  font-weight: 600;
  font-size: 0.875rem;
  color: #374151;
  cursor: pointer;

  &.required::after {
    content: ' *';
    color: #dc2626;
  }
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 0.75rem;
  border: 1px solid ${palette('border', 0)};
  border-radius: 0.375rem;
  font-size: 1rem;
  font-family: inherit;
  line-height: 1.5;
  resize: vertical;
  transition: all 0.2s ease-in-out;
  font-family: JetBrains Mono Regular;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &:hover:not(:focus) {
    border-color: #9ca3af;
  }

  &[aria-invalid='true'] {
    border-color: #dc2626;

    &:focus {
      border-color: #dc2626;
      box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
    }
  }

  &:disabled {
    background-color: #f3f4f6;
    border-color: #d1d5db;
    color: #6b7280;
    cursor: not-allowed;
    resize: none;
  }

  &::placeholder {
    color: #9ca3af;
    font-size: 14px;
  }
`;

export const HelperText = styled.div`
  font-size: 0.75rem;
  color: #6b7280;

  &.error {
    color: #dc2626;
  }
`;

export const CharacterCount = styled.div`
  font-size: 0.75rem;
  color: #6b7280;
  text-align: right;
  margin-top: 0.25rem;

  &.warning {
    color: #f59e0b;
  }

  &.error {
    color: #dc2626;
  }
`;
